export default "__VITE_ASSET__Dxw1Y3qE__"